import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const FloatingButton = () => {
  const [open, setOpen] = useState(false);

  const toggleFAB = () => setOpen(!open);

  return (
    <div
      className={`fab-container ${open ? 'open' : ''} d-none d-sm-block`}
      style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 1000 }}
    >
      <div
        className="fab-button"
        onClick={toggleFAB}
        style={{
          backgroundColor: '#2079BE',
          color: 'white',
          borderRadius: '50%',
          width: '56px',
          height: '56px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer',
          fontSize: '24px',
        }}
      >
        <i className={`fas ${open ? 'fa-times' : 'fa-comments'}`}></i>
      </div>

      <ul className="fab-options" style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {/* WhatsApp with hover dropdown */}
        <li style={{ position: 'relative', marginTop: '10px' }} className="whatsapp-parent">
          <a
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#25d366', fontSize: '30px', display: 'inline-block' }}
          >
            <i className="fab fa-whatsapp"></i>
          </a>
          <ul
            className="whatsapp-dropdown"
            style={{
              position: 'absolute',
              left: '-200px',
              bottom: '-20px',
              right:'40px',
              backgroundColor: 'white',
              boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
              borderRadius: '8px',
              padding: '8px',
              display: 'none',
              flexDirection: 'column',
              gap: '6px',
              minWidth: '160px',
              listStyleType: 'none',
            }}
          >
            <li>
              <a href="https://wa.me/9766439090?text=Hello..." target="_blank" rel="noopener noreferrer" className='w-100 bg-transparent shadow-none'>
                <img src="/assets/images/icons/wp1.png" alt="wp1" className="img-fluid" />
              </a>
            </li>
            <li>
              <a href="https://wa.me/8002949090?text=Hello..." target="_blank" rel="noopener noreferrer" className='w-100 bg-transparent shadow-none'>
                <img src="/assets/images/icons/wp2.png" alt="wp2" className="img-fluid" />
              </a>
            </li>
            <li>
              <a href="https://wa.me/7090119090?text=Hello..." target="_blank" rel="noopener noreferrer" className='w-100 bg-transparent shadow-none'>
                <img src="/assets/images/icons/wp3.png" alt="wp3" className="img-fluid" />
              </a>
            </li>
          </ul>
        </li>

        {/* Phone with hover dropdown */}
        <li style={{ position: 'relative', marginTop: '10px' }} className="phone-parent">
          <a
            style={{ color: '#007bff', fontSize: '24px', display: 'inline-block' }}
          >
            <i className="fas fa-phone-alt"style={{ marginTop: '12px' }}></i>
          </a>
          <ul
            className="phone-dropdown"
            style={{
              position: 'absolute',
              left: '-200px',
              bottom: '0',
              right:'40px',
              backgroundColor: 'white',
              boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
              borderRadius: '8px',
              padding: '8px',
              display: 'none',
              flexDirection: 'column',
              gap: '6px',
              minWidth: '160px',
              listStyleType: 'none',
            }}
          >
            <li>
              <a href="tel:9766439090" className='w-100 bg-transparent shadow-none'>
                <img src="/assets/images/icons/call1.png" alt="wp1" className="img-fluid" />
              </a>
            </li>
            <li>
              <a href="tel:8002949090" className='w-100 bg-transparent shadow-none'>
                <img src="/assets/images/icons/call2.png" alt="wp1" className="img-fluid" />
              </a>
            </li>
            <li>
              <a href="tel:7090119090" className='w-100 bg-transparent shadow-none'>
                <img src="/assets/images/icons/call3.png" alt="wp1" className="img-fluid" />
              </a>
            </li>
          </ul>
        </li>
      </ul>

      {/* CSS for hover behavior */}
      <style>{`
        .whatsapp-parent:hover .whatsapp-dropdown {
          display: flex !important;
        }
        .phone-parent:hover .phone-dropdown {
          display: flex !important;
        }
      `}</style>
    </div>
  );
};

export default FloatingButton;
